/* eslint-disable quote-props */
import { Button, styled } from "@mui/material";

const NewSecondaryButton = styled(Button)(({ theme }) => ({
  width: "100%",
  backgroundColor: theme.palette.taupe.dark,
  border: "1px solid #D6C7BA",
  textAlign: "center",
  textTransform: "capitalize",
  fontWeight: 600,
  "&:hover": {
    backgroundColor: theme.palette.taupe.dark,
    color: theme.palette.common.black,
  },
  "&:focus": {
    backgroundColor: theme.palette.taupe.dark,
    color: theme.palette.common.black,
  },
}));

export default NewSecondaryButton;
